import { Navigate, Route, Routes } from 'react-router-dom';
import OperationsLayout from '../pages/layout/operationsLayout';
import PartnersList from '../pages/partners/partnersList';
import AddNewPartner from '../pages/partners/addNewPartner';
import UserProfile from '../pages/userProfile/profile';
import IntakeForm from '../pages/intakeform/intakformList';
import AddNewIntake from '../pages/intakeform/intake';
import OpsStaffList from '../pages/opsStaff/opsStaffList';
import AddNewOpsStaff from '../pages/opsStaff/addNewOpsStaff';
import FacilityUserList from '../pages/facilities/facilityUserList';
import FacilityList from '../pages/facilities/facilityList';
import CliniciansList from '../pages/clinicians/cliniciansList';
import AuthenticationHandler from '../pages/login/AuthenticationHandler';
import AddNewFacility from '../pages/facilities/addNewFacility';
import AddNewFacilityUser from '../pages/facilities/addNewFacilityUser';
import AddNewClinician from '../pages/clinicians/addNewClinician';
import ConsultList from '../pages/consults/consultsList';
import FacilityClinicianMapingList from '../pages/mapping/facilityClinicianMapingList';
import AddFacilityClinicianMapping from '../pages/facilities/addFacilityClinicianMapping';
import PartnerView from '../pages/partners/partnerView';
import FacilityView from '../pages/facilities/facilityView';
import FacilityUserView from '../pages/facilities/facilityUserView';
import ViewOpsStaff from '../pages/opsStaff/opsStaffView';
import ClinicianDetailsView from '../pages/clinicians/clinicianDetailsView';
import AddNewConsults from '../pages/consults/addNewConsult';
import ConsultView from '../pages/consults/consultView';
import AccessDenied from '../pages/login/access-denied';
import NotFound from '../pages/login/NotFound';
import FacilityDetailsComponent from '../pages/facilities/FacilityDetailsComponent';
import ConsultMoreDetailsOps from '../pages/consults/ConsultMoreDetailsOps';
import FacilityClinicianMappingView from '../pages/facilities/FacilityClinicianMappingView';

const Routing = () => {
  return (
    <Routes>
      <Route path="/access-denied" element={<AccessDenied />} />
      <Route
        path="/"
        element={
          <AuthenticationHandler>
            <Navigate to="/ops" replace />
          </AuthenticationHandler>
        }
      />
      <Route
        path="/ops/*"
        element={
          <AuthenticationHandler>
            <OperationsLayout />
          </AuthenticationHandler>
        }
      >
        {/* <Route element={<OperationsLayout />}> */}
        <Route path="partners">
          <Route index element={<PartnersList />} />
          <Route path="new" element={<AddNewPartner />} />
          <Route path="view/:partnerId" element={<PartnerView />} />
          <Route path="new/:partnerId" element={<AddNewPartner />} />
        </Route>
        <Route path="facility">
          <Route index element={<FacilityList />} />
          <Route path="partner/:partnerId" element={<FacilityList />} />
          <Route path="clinician/:clinicianId" element={<FacilityList />} />
          <Route path="new" element={<AddNewFacility />} />
          <Route path="new/:facilityId" element={<AddNewFacility />} />
          <Route path="view/:facilityId" element={<FacilityView />} />
          <Route
            path="mapped-list/:facilityId"
            element={<FacilityClinicianMapingList />}
          />
          <Route
            path="mapped-list/new/:facilityId"
            element={<AddFacilityClinicianMapping />}
          />
          <Route
            path="mapping/view/:facilityId"
            element={<FacilityClinicianMappingView />}
          />
          <Route path="details" element={<FacilityDetailsComponent />} />
        </Route>
        <Route path="facility-users">
          <Route path="users">
            <Route index element={<FacilityUserList />} />
            <Route path="new" element={<AddNewFacilityUser />} />
            <Route
              path="new/:facilityUserId"
              element={<AddNewFacilityUser />}
            />

            <Route path="view/:facilityUserId" element={<FacilityUserView />} />
          </Route>

          {/* <Route
                path="user/view/:facilityUserId"
                element={<FacilityUserView />}
              /> */}
        </Route>
        <Route path="clinicians">
          <Route index element={<CliniciansList />} />
          <Route path="new" element={<AddNewClinician />} />
          <Route path="new/:clinicianId" element={<AddNewClinician />} />
          <Route path="view/:clinicianId" element={<ClinicianDetailsView />} />
          <Route
            path="mapped-list/:clinicianId"
            element={<FacilityClinicianMapingList />}
          />
          <Route
            path="mapping/view/:clinicianId"
            element={<FacilityClinicianMappingView />}
          />
          <Route
            path="mapped-list/new/:clinicianId"
            element={<AddFacilityClinicianMapping />}
          />
        </Route>
        <Route path="consults">
          <Route index element={<ConsultList />} />
          <Route path="new" element={<AddNewConsults />} />
          <Route path="new/:consultId" element={<AddNewConsults />} />
          <Route path="view/:consultId" element={<ConsultView />} />
          <Route
            path="more-details/:consultId"
            element={<ConsultMoreDetailsOps />}
          />
        </Route>
        <Route path="opsuser">
          <Route index element={<OpsStaffList />} />
          <Route path="new" element={<AddNewOpsStaff />} />
          <Route path="new/:opsStaffId" element={<AddNewOpsStaff />} />
          <Route path="view/:opsStaffId" element={<ViewOpsStaff />} />
        </Route>
        <Route path="profile" element={<UserProfile />} />
        <Route path="intake">
          <Route index element={<IntakeForm />} />
          <Route path="new" element={<AddNewIntake />} />
          <Route path="new/:intakeFormId" element={<AddNewIntake />} />
        </Route>
        <Route path="*" element={<NotFound />} />
        {/* </Route> */}
      </Route>
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};
export default Routing;
